import React, { useState } from 'react'
import { Alert, Button, Col, Container, Row } from 'react-bootstrap'
import ExamenDiagnosticoLecturaVeloz from './ExamenDiagnosticoLecturaVeloz'
import TitleDashboard from '@components/general/Titles/TitleDashboard';
import Swal from 'sweetalert2';
import { Notificacion } from '@components/general/Alertas/Alertas';
import { Movie, Warning } from '@mui/icons-material';

const FormExamenDiagnostico = ({codigoExamenDiagnostico, usuarioLogeado, setRealizarExamenDiagnostico, semanaAvance, handleScrollToTop}) => {

    const [mostrarResultadosEvaluacion, setMostrarResultadosEvaluacion] = useState(false);
    

    //Logica para mostrar los componenetes del diagnostico:
    /**
     * Instructivo de la evaluacion
     * Se muestra el componente de examen diagnostico para comenzar con la evaluacion.
     * Dentro del componente de examen se evaluará y se harán los ajustes en el progreso al usuario que se esté evaluando
     * 
     * *Se Podrá resetear todo el progreso no sin antes recomendarselo al estudiante, además de que se podrá mantener el progreso actual en el curso una vez que comprueba que cumple con las condiciones.
     */

    const [realizarExamen, setRealizarExamen] = useState(false);

    const handleHacerEvaluacion = () => {
        setRealizarExamen(true);
    }

    const regresar = async() => {

        const { isConfirmed } = await Swal.fire({
            title: "¿Seguro que quieres salir?",
            text: "Estás a punto regresar, tendrás que comenzar la evaluación de nuevo",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "Entendido",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#0d6efd",
            allowOutsideClick: false,
        });

        if (!isConfirmed) {

            return Notificacion("info", "Puedes continuar con tu evaluación");
        }

        // setRealizarExamenDiagnostico(false);
        window.location.reload();


    }

  return (
    <>
    <Row className="mt-5 mx-2 mb-5 justify-content-around">
        <Col className="text-start col-12 col-md-auto">
            <TitleDashboard title={"Exámen diagnóstico"}/>
        </Col>

        {!mostrarResultadosEvaluacion ? (
             <Col className="text-start col-12 col-md-auto mt-3 mt-md-0">
                <Button onClick={regresar} className='btn-danger'>Regresar</Button>
            </Col>
        ): null}
    </Row>


    {/* Componente dividido en varias etapas: instructivo, lectura, evaluacion, resultados y ajuste de avance */}

    {realizarExamen ? (
        <Row className="p-0">
            <Col className="text-center">
                <ExamenDiagnosticoLecturaVeloz codigoExamenDiagnostico={codigoExamenDiagnostico} usuarioLogeado={usuarioLogeado} mostrarResultadosEvaluacion={mostrarResultadosEvaluacion} setMostrarResultadosEvaluacion={setMostrarResultadosEvaluacion} handleScrollToTop={handleScrollToTop} setRealizarExamenDiagnostico={setRealizarExamenDiagnostico} semanaAvance={semanaAvance} />
            </Col>
        </Row>
    ) : (
        <Row className="px-0 pb-5 justify-content-center mb-5">
            <Col lg={8} className="text-center p-4 rounded" style={{ backgroundColor: "#dcfcca", fontSize: '16px' }}>

                <h3><strong>Instrucciones de la evaluación</strong></h3>

                <span className='mt-4'>
                    Bienvenido(a) a la evaluación diagnóstica del curso Comprensión y Lectura Inteligente. Esta evaluación tiene como propósito obtener tu velocidad de lectura (ppm) y porcentaje de comprensión lectora. Con esta información podremos brindarte un acompañamiento adecuado y asegurar el desarrollo de tus habilidades lectoras. <b>La realización de esta prueba es obligatoria</b>, asegúrate de realizarla en un ambiente tranquilo y con poco ruido, necesitarás concentrarte y prestar toda tu atención al ejercicio.
                </span>


                <div className='text-start my-4'>
                    <span>Una vez concluida la evaluación, se realizará uno de los siguientes cambios:</span>
                    <ul>
                        <li>Se podrá ajustar tu progreso a la semana adecuada a tu nivel de lectura y comprensión.</li>
                        <li>Se podrá reiniciar por completo tu progreso, dandote la oportunidad de hacerlo de manera adecuada para sacar el mayor provecho al curso.</li>
                        <li>Conservar tu progreso, dejandote continuar el curso con tu nivel de lectura y comprensión obtenidos en la evaluación.</li>
                    </ul>
                </div>

                <span>Tu participación responsable es fundamental para que el programa cumpla su objetivo de ayudarte a desarrollar y mejorar tu lectura y comprensión lectora de manera efectiva.</span>

                <div>
                    <Button onClick={handleHacerEvaluacion} className="btn btn-success mt-4">Comenzar evaluación</Button>
                </div>
            </Col>

            <Col className='mb-1 mt-3 p-0 text-center' lg={8}>
                <Alert variant='light'>
                    <p style={{ fontSize: "14px" }} className="text-success text-center">
                       <b> <span className='text-danger'></span> <span className="text-dark">Mira el siguiente video de recomendaciones antes de comenzar con tu evaluación</span></b>
                    </p>

                    <p>
                        <a href='https://globalclicklatam.com/videos/recomendaciones-lectura.mp4' target='_blank' className='btn btn-primary btn-sm'><Movie /> Ver video</a>
                    </p>

                </Alert>
            </Col>

            <Col className='mb-5 p-0' lg={8}>
                <Alert variant='warning'>
                    <p style={{ fontSize: "14px" }} className="text-success text-center">
                       <b> <span className='text-danger'><Warning /></span> <span className="text-dark">Al concluir tu evaluación, no será posible repetirla. Cualquier ajuste que se realice después de su revisión será permanente.</span></b>
                    </p>

                </Alert>
            </Col>
            {/* <Col className='col-12 text-center mt-5'>
                <Button onClick={handleHacerEvaluacion} className="btn btn-primary">Comenzar evaluación</Button>
            </Col> */}
        </Row>
    )}

   
    </>
  )
}

export default FormExamenDiagnostico